<template>
    <transition name="fade-slide" @before-leave="beforeLeave" @leave="leave">
        <div v-if="message" class="alert" :class="`${type}`" role="alert">
            <p v-html="getMessage()"></p>
            <button type="button" class="btn small" @click="$emit('close')">
                <i class="bi bi-x-lg" title="Fechar"></i>
            </button>
        </div>
    </transition>
</template>

<script>
export default {
    name: "AlertComponent",
    props: {
        type: {
            type: String,
            default: "info",
        },
        message: {
            type: String,
            default: "",
        },
    },
    methods: {
        getMessage() {
            return this.message.replace(/\n/g, "<br/>");
        },
        beforeLeave(el) {
            el.style.height = `${el.offsetHeight}px`;
            el.style.marginTop = getComputedStyle(el).marginTop;
            el.style.marginBottom = getComputedStyle(el).marginBottom;
            el.style.paddingTop = getComputedStyle(el).paddingTop;
            el.style.paddingBottom = getComputedStyle(el).paddingBottom;
            el.style.transition = "height 0.5s ease, margin 0.5s ease, padding 0.5s ease, opacity 0.2s ease";
        },
        leave(el) {
            el.style.height = "0";
            el.style.marginTop = "0";
            el.style.marginBottom = "0";
            el.style.paddingTop = "0";
            el.style.paddingBottom = "0";
            el.style.opacity = "0";
        },
    },
};
</script>

<style scoped src="@/assets/css/general/alert-style.css"></style>